import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const Data = (props: SvgIconProps): React.ReactNode => {
  return (
    <SvgIcon {...props}>
      <path d="M12.1111 4C8.18222 4 5 5.59111 5 7.55556C5 9.52 8.18222 11.1111 12.1111 11.1111C16.04 11.1111 19.2222 9.52 19.2222 7.55556C19.2222 5.59111 16.04 4 12.1111 4ZM5 9.33333V12C5 13.9644 8.18222 15.5556 12.1111 15.5556C16.04 15.5556 19.2222 13.9644 19.2222 12V9.33333C19.2222 11.2978 16.04 12.8889 12.1111 12.8889C8.18222 12.8889 5 11.2978 5 9.33333ZM5 13.7778V16.4444C5 18.4089 8.18222 20 12.1111 20C16.04 20 19.2222 18.4089 19.2222 16.4444V13.7778C19.2222 15.7422 16.04 17.3333 12.1111 17.3333C8.18222 17.3333 5 15.7422 5 13.7778Z" />
    </SvgIcon>
  )
}

export default Data
